import React__default from 'react';
import BottomSheet from './BottomSheet.js';
import { L as Label, a as LabelTypography, b as LabelColors } from '../chunks/bundle-DNnUvjnZ.js';
import { u as useLocalization } from '../chunks/bundle-DWyboFhb.js';
import 'react-dom';
import '../chunks/bundle-Bd7J49Pj.js';
import '../chunks/bundle-BXYHgzRj.js';
import '../chunks/bundle-CGbKAqtd.js';
import '@sendbird/chat/groupChannel';
import '../utils/message/getOutgoingMessageState.js';
import '../chunks/bundle-CXA05pe2.js';
import '../chunks/bundle-DokyceKk.js';
import '../chunks/bundle-Dz4_R08c.js';
import '../chunks/bundle-u-vzK-oc.js';
import '../chunks/bundle-DtujCCHB.js';
import './IconButton.js';
import './Button.js';
import './Icon.js';
import '@sendbird/uikit-tools';
import '../withSendbird.js';
import 'css-vars-ponyfill';
import '@sendbird/chat';
import '../chunks/bundle-ClfkSu0m.js';
import '@sendbird/chat/openChannel';
import '../chunks/bundle-C4eUm39A.js';
import '../useSendbirdStateContext.js';
import '../chunks/bundle-CZybJwCN.js';
import './SortByRow.js';
import '../chunks/bundle-CqMQE3-R.js';

function MobileFeedbackMenu(props) {
    var hideMenu = props.hideMenu, onEditFeedback = props.onEditFeedback, onRemoveFeedback = props.onRemoveFeedback;
    var stringSet = useLocalization().stringSet;
    return (React__default.createElement(BottomSheet, { onBackdropClick: hideMenu },
        React__default.createElement("div", { className: 'sendbird-message__bottomsheet--feedback-options-menu' },
            React__default.createElement("div", { className: 'sendbird-message__bottomsheet--feedback-option', onClick: function () {
                    hideMenu();
                    onEditFeedback();
                } },
                React__default.createElement(Label, { type: LabelTypography.BODY_1, color: LabelColors.ONBACKGROUND_1 }, stringSet.EDIT_COMMENT)),
            React__default.createElement("div", { className: 'sendbird-message__bottomsheet--feedback-option', onClick: function () {
                    hideMenu();
                    onRemoveFeedback();
                } },
                React__default.createElement(Label, { type: LabelTypography.BODY_1, color: LabelColors.ERROR }, stringSet.REMOVE_FEEDBACK)))));
}

export { MobileFeedbackMenu as default };
//# sourceMappingURL=MobileFeedbackMenu.js.map
